var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","color":_vm.meta.color,"text-color":"white"}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v(_vm._s(_vm.meta.icon))]),_vm._v(" "+_vm._s(_vm.meta.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }